import { Button } from "primereact/button";
import { Knob } from "primereact/knob";
import { useNavigate, useOutletContext } from "react-router-dom";
import { TEXT_NORMAL, TEXT_SMALL } from "../../style";
import "./selfTestShow.css";

export default function Result() {
    const { testResult } = useOutletContext();
    const navigate = useNavigate();

    const total = testResult?.questions?.length || (testResult?.questionsAttended || 0) + (testResult?.skip || 0);
    const percentage = total ? Math.round(((testResult?.correctAnswers || 0) / total) * 100) : 0;

    const details = [
        { label: "Score", value: testResult?.correctAnswers || 0 },
        { label: "Incorrect Answers", value: testResult?.incorrectAnswers || 0 },
        { label: "Skip", value: testResult?.skip || 0 },
        { label: "Attended", value: testResult?.questionsAttended || 0 },
    ];

    return (
        <div className="self-test-page flex flex-column align-items-center gap-3 p-3 min-h-full">
            <Knob
                value={percentage}
                readOnly
                valueTemplate="{value}%"
                valueColor="#18b957"
                rangeColor="#f5b942"
                textColor="#ffffff"
                size={160}
                strokeWidth={12}
            />

            <div className="w-full flex flex-column gap-2 border-1 border-yellow-300 border-round-xl px-3 py-3">
                {details.map(({ label, value }) => (
                    <div key={label} className="flex align-items-center justify-content-between">
                        <span className={`${TEXT_SMALL} text-white`}>{label}</span>
                        <span className={`${TEXT_NORMAL} text-yellow-300 font-bold`}>{value}</span>
                    </div>
                ))}
            </div>

            <Button label="Retry" className="w-full" severity="warning" onClick={() => navigate("../selection")} />
        </div>
    );
}
